<script >
import { ref, computed, onMounted } from 'vue-demi';
import { useRateMethod, useCommonMethod } from '../../../../common/utils/index';
import { useFego } from '../../../../common/utils/useFego';
import { useRateClsByApp } from '../../../../common/utils/rateByApp';
import { typeMapApiName, getIncreaseTag } from '../../../../common/utils/increase';
const __sfc_main = {};
__sfc_main.props = ['followApp', 'defaultRateCol', 'rateLang', 'model', 'name', 'newCode', 'ccy', 'flags', 'increaseType', 'titleSize'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useCommonApi
  } = require('@fegobull/webapi').use;

  /** props */
  const props = __props;

  /** ref */
  const increase = ref('---');

  /** common method */
  const {
    isRender
  } = useFego();
  const {
    jumpToFund,
    splitFlag
  } = useCommonMethod();
  const {
    getRateClass,
    getRateSymbol
  } = useRateMethod();
  const rateColorCls = useRateClsByApp(props.followApp, props.defaultRateCol);
  const flagList = computed(() => {
    return splitFlag(props.flags);
  });

  /** 请求数据 */
  const fetchFundRate = async () => {
    if (!isRender.value) {
      return;
    }
    try {
      const apiRequest = useCommonApi('fund-card-big-sw');
      increase.value = await apiRequest.get(typeMapApiName[props.increaseType], {
        code: props.newCode
      });
    } catch (err) {
      console.error(err);
    }
  };
  onMounted(() => {
    fetchFundRate();
  });
  return {
    getIncreaseTag,
    props,
    increase,
    jumpToFund,
    getRateClass,
    getRateSymbol,
    rateColorCls,
    flagList
  };
};
export default __sfc_main;
</script>

<template>
    <div
        class="fund-card-hori"
        :class="[rateColorCls, `local-${props.rateLang}`]"
        @click="jumpToFund($event, props.newCode)"
    >
        <div class="left">
            <h6 v-if="increase" class="increase" :class="[getRateClass(increase)]">
                {{ getRateSymbol(increase) }}{{ increase }}
            </h6>
            <p class="increaseTag">
                <span>{{ getIncreaseTag(props.increaseType, props.rateLang) }}</span>
            </p>
        </div>
        <div class="right">
            <template v-if="props.model === '1'">
                <h6 class="name" :style="titleSize">
                    {{ name }}
                </h6>
                <ul class="flagList">
                    <li>{{ props.ccy }}</li>
                    <li v-for="item in flagList" :key="item">{{ item }}</li>
                </ul>
            </template>
            <template v-else>
                <h6 class="name">
                    {{ props.flags }}
                </h6>
                <p class="desc">
                    <span class="ccy">{{ props.ccy }}</span>
                    <span>{{ name }}</span>
                </p>
            </template>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import '../index.less';
</style>
